import { captureException } from '@sentry/browser';
import clientConfig from '../client/config';

const componentDidCatch = (error: Error, _info: Object) => {
  if (
    clientConfig.sentry &&
    clientConfig.sentry.dsn &&
    clientConfig.sentry.config
  ) {
    captureException(error);
  } else {
    console.error('[ErrorBoundary error]', error, _info);
  }
};

export default componentDidCatch;
